import onDomReady from '../../utils/dom/onDomReady';
import FormTabValidation from '../../features/formTabs/FormTabValidation';

onDomReady(() => {
  new FormTabValidation().init();
});
